import React from 'react';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';
import SMRestClient from 'lib/SMRestClient';
import SMConst from 'lib/SMConst';

class SMDashboardView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      announcements: [],
      todoItems: [],
      pendingReservations: [],
      requestedReservations: [],
      paidReservations: [],
      priceRecommends: {},
      hasMorePendingReservations: false,
      hasMoreRequestedReservations: false,
      hasMorePaidReservations: false,
      completeCounter: 0,
      companies: [],
    };
  }

  componentDidMount() {
    if (SMAppHelper.isMobile()) {
      $('body').addClass('sp').addClass('sp-top');
    }
    this.requestResource();
    $(this.refs.container).startLoading({modalOpacity: 0});
  }


  renderAnnouncements() {
    if (this.state.announcements.length == 0) return null;
    const rows = this.state.announcements.map(function(announcement, i){
      return(
        <li key={announcement.id} className="dashboard-top__main-info-list">
          <p><a target="_blank" href={announcement.link} className="link-hover-border">{announcement.content}</a></p>
        </li>
      );
    });

    return (
      <ul className="dashboard-top__main-info">
        {rows}
      </ul>
    );
  }

  renderTodoItems() {
    return (
      <div>
        <h2 className="dashboard-title mb20">やることリスト</h2>
        {(()=>{
          if (this.state.todoItems.length == 0){
            return <p key="none" className="message-supplement mb50">現在やることリストはありません。</p>;
          } else {
            const rows = this.state.todoItems.map(function(todoItem, i){
              return(
                <li key={i} className="dashboard-top__main-list">
                  <div className="dashboard-top__main-list-box dashboard-top__todo-icon"><img src={SMRailsBridge.assetPath.userSpaceMarketIcon} alt="スペースマーケット" className="dashboard-top__main-list-icon" /></div>
                  <div className="dashboard-top__main-list-box"><p className="dashboard-top__todo-content"><a href={todoItem.link} className={`link-hover-border ${todoItem.type == SMConst.TodoItemType.OwnerBanned ? 'is-error' : ''}`}>{todoItem.content}</a></p></div>
                </li>
              );
            });
            return <ul className="dashboard-top__main-listarea">{rows}</ul>;
          }
        })()}
      </div>
    );
  }

  handleResponseDashboard(responses, error, xhr) {
    this.setState({completeCounter: this.state.completeCounter + 1});
    if (this.state.completeCounter + 1 > this.props.completeMaxCount) $(this.refs.container).stopLoading();
    if(error || !responses) return;
    this.setState({
      announcements: responses.announcements || [],
      todoItems: responses.todo_items || [],
    });
  }

  handleResponsePending(responses, error, xhr) {
    this.setState({completeCounter: this.state.completeCounter + 1});
    if (this.state.completeCounter + 1 > this.props.completeMaxCount) $(this.refs.container).stopLoading();
    if(error || !responses) return;
    const links = SMRestClient.getLinks(xhr);
    let state = this.state;
    state.pendingReservations = responses;
    state.hasMorePendingReservations = (links["next"]);
    this.setState(state);
  }

  handleResponseRequested(responses, error, xhr) {
    this.setState({completeCounter: this.state.completeCounter + 1});
    if (this.state.completeCounter + 1 > this.props.completeMaxCount) $(this.refs.container).stopLoading();
    if(error || !responses) return;
    const links = SMRestClient.getLinks(xhr);
    let state = this.state;
    state.requestedReservations = responses;
    state.hasMoreRequestedReservations = (links["next"]);
    this.setState(state);
  }

  handleResponsePaid(responses, error, xhr) {
    this.setState({completeCounter: this.state.completeCounter + 1});
    if (this.state.completeCounter + 1 > this.props.completeMaxCount) $(this.refs.container).stopLoading();
    if(error || !responses) return;
    const links = SMRestClient.getLinks(xhr);
    let state = this.state;
    state.paidReservations = responses;
    state.hasMorePaidReservations = (links["next"]);
    this.setState(state);
  }
}
export default SMDashboardView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMDashboardView.jsx